<template>
  <div class="video-layer" @keyup.esc="toggleLayer(false)">
    <div v-show="openLayer" class="video-layer__modal video" role="dialog" aria-modal="true">
      <button ref="closeBtn" type="button" class="btn-close" @click="toggleLayer(false)">
        <slot name="closebtn" />
        <span class="btn--close" />
      </button>
      <loader v-if="isLoading" />
      <video-main
        v-if="ajaxCallDone && openLayer"
        :key="videoID"
        :video="videoID"
        :flowid="flowid"
      />
      <div class="video__content container--medium">
        <div class="container--small">
          <div class="video__title" v-html="title" />
          <div class="video__text" v-html="copy" />
          <div class="video__transcript" v-html="transcript" />
        </div>
        <div class="container--large">
          <div class="container--small">
            <div class="copy-block container--small content fadein--bottom">
              <div
                v-if="richTextDetails.RichTextOnlyOneColumn"
                class="copy-block__title copy-block--fullwidth copy-block--imgdisplay"
                v-html="richTextDetails.RichText"
              />
              <div
                v-if="!richTextDetails.RichTextOnlyOneColumn"
                class="copy-block__title copy-block--imgdisplay"
                v-html="richTextDetails.RichTitle"
              />
              <div
                v-if="!richTextDetails.RichTextOnlyOneColumn"
                class="copy-block__text copy-block--imgdisplay"
                v-html="richTextDetails.RichText"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { fetchData } from '../../../utilities/services';
import { removePageScroll } from '../../../utilities/mixins/remove-page-scroll';
/* eslint-disable */
export default {
  name: 'video-layer',
  components: {
    loader: () => import('../../loader/loader.vue'),
  },

  mixins: [removePageScroll],
  props: {
    url: {
      type: String,
      default: null,
    },
    flowid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      openLayer: false,
      videoID: null,
      transcript: null,
      copy: null,
      ajaxCallDone: false,
      pageUrl: null,
      focusElement: null,
      title: null,
      isLoading: false,
      richTextDetails: '',
    };
  },
  methods: {
    toggleLayer(value) {
      this.openLayer = value;

      this.toggleLayerAddKeydownEvent();

      this.removePageScroll(value);
      if (value === false) {
        this.toggleLayerNonActive();
        this.ajaxCallDone = false;
        this.videoID = null;
      } else {
        this.toggleLayerActive();
      }
    },
    toggleLayerAddKeydownEvent() {
      const focusableElementsArray = ['button', 'div.fp-middle', '[href]'];

      const modals = document.querySelectorAll('.video-layer'); // select the modal by it's id
      modals.forEach((modal) => {
        let focusableContent;
        let lastFocusableElement;
        let firstFocusableElement;
        document.addEventListener('keydown', function (e) {
          firstFocusableElement = modal.querySelectorAll(focusableElementsArray)[0]; // get first element to be focused inside modal
          focusableContent = modal.querySelectorAll(focusableElementsArray);
          lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
          lastFocusableElement.tabIndex = 0;
          const isTabPressed = e.key === 'Tab';
          if (!isTabPressed) {
            return;
          }

          if (e.shiftKey) {
            // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableElement) {
              lastFocusableElement.focus(); // add focus for the last focusable element
              e.preventDefault();
            }
          } else {
            // if tab key is pressed
            if (document.activeElement === lastFocusableElement) {
              // if focused has reached to last focusable element then focus first focusable element after pressing tab
              firstFocusableElement.focus(); // add focus for the first focusable element
              e.preventDefault();
            }
          }
        });
      });
    },
    toggleLayerActive() {
      window._uxa = window._uxa || [];
      window._uxa.push([
        'trackPageview',
        window.location.pathname +
          window.location.hash.replace('#', '?__') +
          '?cs-popin-brands-video',
      ]);
      setTimeout(() => {
        this.$refs.closeBtn.focus();
      }, 500);
    },
    toggleLayerNonActive() {
      window.history.pushState(null, null, decodeURIComponent(this.pageUrl));
      window._uxa = window._uxa || [];
      window._uxa.push([
        'trackPageview',
        window.location.pathname + window.location.hash.replace('#', '?__'),
      ]);
      setTimeout(() => {
        this.focusElement.focus();
      }, 500);
    },
    videoCall(focusElement) {
      this.pageUrl = window.location.href;
      this.isLoading = true;
      this.focusElement = focusElement;
      fetchData(this.url).then((video) => {
        this.videoID = video.VideoId;
        this.transcript = video.Transcript;
        this.copy = video.Copy;
        this.title = video.Title;
        this.richTextDetails = video;
        this.ajaxCallDone = true;
        this.toggleLayer(true);
        this.isLoading = false;
        this.$nextTick(() => {
          window.history.pushState(null, null, decodeURIComponent(video.PageUrl));
        });
      });
    },
  },
};
</script>
